import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Typography } from '@npm-registry/eapteka-ui';
import { text } from '../../../../text';
import { formatDate } from '../../../../helpers/formatters/formatDate/formatDate';
import { PreorderIcon } from '..';
import { PreorderLabelProps } from '../types';
import styles from './PreorderLabel.scss';

export const PreorderLabel: FC<PreorderLabelProps> = ({
  className,
  date
}) => {
  const rootClassNames = clsx([styles.root, className]);
  const dateString = useMemo(
    () =>
      formatDate(date, {
        month: 'long',
        day: 'numeric'
      }),
    [date]
  );

  return (
    <div className={rootClassNames}>
      <PreorderIcon className={styles.icon} />
      <Typography className={styles.title}>
        {text['preorder.label.title']}
        {dateString}
      </Typography>
    </div>
  );
};
